import axios from 'axios'
import store from '@/store'
import * as types from '@/store/mutation-types'
import iziToast from 'izitoast'

var myAxios = axios.create({
  baseURL: '/api/v1'
})
myAxios.interceptors.response.use((response) => { // intercept the global error
  return response
}, function (error) {
  if (error.response.status === 401) {
    if (myAxios.defaults.headers.common['Authorization'] !== undefined) {
      store.dispatch(types.AUTH_LOGOUT)
    }
  }
  if (error.response.status === 404) {
  }
  if (error.response.status === 403) {
    iziToast.show({
      message: 'Brak uprawnień do wykonania czynności.',
      color: 'red'
    })
  }
  // Do something with response error
  return Promise.reject(error)
})

export default myAxios



// WEBPACK FOOTER //
// ./src/utils/api.js